/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_ReactivateInputs */

const en_task_flow_reactivate = /** @type {(inputs: Task_Flow_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactivate`)
};

const pt_br2_task_flow_reactivate = /** @type {(inputs: Task_Flow_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reativar`)
};

/**
* | output |
* | --- |
* | "Reactivate" |
*
* @param {Task_Flow_ReactivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_reactivate = /** @type {((inputs?: Task_Flow_ReactivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_ReactivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_reactivate(inputs)
	return pt_br2_task_flow_reactivate(inputs)
});